var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('keep-alive',[_c('router-view',{key:_vm.$route.fullPath,staticClass:"document",on:{"update":_vm.initDocument}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }